import * as React from "react";
import styles from "./ProgressBar.module.scss";

type ProgressBarProps = {
  min: number;
  max: number;
  value: number;
  labelMin?: string;
  labelMax?: string;
};

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const progress = Math.round((props.value / props.max) * 100) / 100;

  return (
    <div className={styles.wrapper}>
      {props.labelMin && <div>{props.labelMin}</div>}
      <div className={styles.bar}>
        <div className={styles.progress} style={{transform: `scaleX(${progress})`}} />
      </div>
      {props.labelMax && <div>{props.labelMax}</div>}
    </div>
  );
};

export default ProgressBar;
